export default __webpack_public_path__ + "static/media/RealCase.7c5aa5fb.png";